import { flow, map, kebabCase } from 'lodash/fp';
import prepareOptions from '../../prepareOptions';
import {
  CONVERTIBLE,
  CONVERTIBLE_COUPE,
  STATION_WAGON,
  LIMOUSINE,
  SUV_PICKUP,
  VAN_TRANSPORTER,
  COUPE_SPORT,
  OTHER,
  SMALL_CAR,
  ROADSTER,
} from './values';

const options = [
  {
    label: __('carDetails.bodyType.smallCar'),
    value: SMALL_CAR,
  },
  {
    label: __('carDetails.bodyType.cabrio'),
    value: CONVERTIBLE,
  },
  {
    label: __('carDetails.bodyType.combi'),
    value: STATION_WAGON,
  },
  {
    label: __('carDetails.bodyType.convertibleCoupe'),
    value: CONVERTIBLE_COUPE,
  },
  {
    label: __('carDetails.bodyType.suvPickup'),
    value: SUV_PICKUP,
  },
  {
    label: __('carDetails.bodyType.limousine'),
    value: LIMOUSINE,
  },
  {
    label: __('carDetails.bodyType.van'),
    value: VAN_TRANSPORTER,
  },
  {
    label: __('carDetails.bodyType.coupe'),
    value: COUPE_SPORT,
  },
  {
    label: __('carDetails.bodyType.roadster'),
    value: ROADSTER,
  },
  {
    label: __('carDetails.bodyType.other'),
    value: OTHER,
  },
];

export default flow(
  prepareOptions,
  map(({ value, ...rest }) => ({
    ...rest,
    value,
    bodyType: kebabCase(value),
  })),
)(options);
